import { NavLink, Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Plug, Building2, CalendarClock, Search, DollarSign, Plane } from 'lucide-react'

const settingsNavigation = [
  {
    name: 'Business Profile',
    href: 'business',
    icon: Building2,
    description: 'Company info, website & branding',
  },
  {
    name: 'SEO & Attribution',
    href: 'seo',
    icon: Search,
    description: 'Search optimization & conversion tracking',
  },
  {
    name: 'Booking',
    href: 'booking',
    icon: CalendarClock,
    description: 'Booking rules & balance reminders',
  },
  {
    name: 'Pricing',
    href: 'pricing',
    icon: DollarSign,
    description: 'Rates, flat rates & fees',
  },
  {
    name: 'Airports',
    href: 'airports',
    icon: Plane,
    description: 'Configure serviced airports',
  },
  {
    name: 'Integrations',
    href: 'integrations',
    icon: Plug,
    description: 'Connect third-party services',
  },
]

export function SettingsLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Manage your account settings and integrations
        </p>
      </div>

      <div className="flex flex-col gap-8 md:flex-row">
        {/* Sidebar Navigation */}
        <aside className="md:w-64 flex-shrink-0">
          <nav className="flex flex-col gap-1">
            {settingsNavigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                end={item.href === ''}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
                    isActive
                      ? 'bg-secondary text-secondary-foreground'
                      : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                  )
                }
              >
                <item.icon className="h-4 w-4" />
                <div className="flex flex-col">
                  <span className="font-medium">{item.name}</span>
                  <span className="text-xs text-muted-foreground hidden md:block">
                    {item.description}
                  </span>
                </div>
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Content Area */}
        <main className="flex-1 max-w-2xl">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
